import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);

const LineChart = ({ materialData ,yaxis }) => {
    // console.log('materialData', materialData)
    const chartData = materialData;
    // Extract labels (dates)
    const labels = chartData?.map(entry => entry.date);

    // Extract all brand names dynamically
    const allBrands = Array.from(
        new Set(
            chartData?.flatMap(entry => Object.keys(entry.brands))
        )
    );

    // Assign colors to each brand
    const brandColors = {
        Sleepwell: '#8e44ad',
        Wakefit: '#3498db',
        SleepyCat: '#e67e22',
        Sleepyhead: '#d91e18',
        duroflex: '#16a085',
        'Kurl-On': '#f39c12'
    };

    // Create datasets
    const datasets = allBrands?.map(brand => ({
        label: brand,
        data: chartData.map(entry => entry.brands[brand] ?? null),
        borderColor: brandColors[brand] || '#000',
        backgroundColor: brandColors[brand] || '#000',
        tension: 0.3,
        spanGaps: true
    }));

    const data = {
        labels,
        datasets
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    maxRotation: 45,
                    minRotation: 45
                },
                grid: {
                    display: false
                }
            },
            y: {
                title: {
                    display: true,
                    text: yaxis
                }
            }
        },
        plugins: {
            legend: {
                display: true,
                position: 'top'
            },
            tooltip: {
                mode: 'index',
                intersect: false
            }
        }
    };

    return (
        <div style={{ width: '100%', height: 400 }}>
            <Line data={data} options={options} />
        </div>
    );
};

export default LineChart;
